<template>
    <v-container grid-list-xl>

    <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left"  background-color="blue-grey lighten-4" horizontal>
      <v-tabs-slider></v-tabs-slider> 
      <v-tab>
        <v-icon left>fas fa-project-diagram</v-icon>Flujos
      </v-tab>       
      <v-tab>
        <v-icon left>fas fa-cogs</v-icon>Motor
      </v-tab> 
      <v-tab>
        <v-icon left>fas fa-search</v-icon>Busqueda
      </v-tab>       
      <v-tab-item>        
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de flujos</v-card-title>
          <v-card-text >    
            <v-layout row wrap>
                <v-flex sm6 xs12>
                  <v-select
                  :items="gprocesosactivos"
                  v-model="ProcessSelected"
                  item-text="nombre"
                  item-value="idproceso"
                  label="Seleccione un proceso"
                ></v-select>
                </v-flex>
                <v-flex sm3 xs8 v-show="ProcessFrom == 1">
                  <v-text-field
                    v-model="CodeIndicdor"
                    label="Codigo del Indicador: *"
                  ></v-text-field>
                </v-flex>
                <v-flex sm3 xs8 v-show="ProcessFrom == 2">
                  <v-text-field
                    v-model="NamePlan"
                    label="Nombre PNS: *"
                  ></v-text-field>
                </v-flex>  
                <v-flex sm3 xs4 v-show="ProcessFrom != 0">    
                  <v-btn text @click="SearchRecords">Buscar</v-btn>  
                  <v-btn text @click="LimpiarRecords">Limpiar</v-btn>  
                </v-flex>     

                <v-divider></v-divider>
            
            <div v-if="ProcessSelected != 4" style="width: 100%;">
            <v-flex xs12 sm12 v-if="gindicadorflujo != null">
              <v-card v-show="gindicadorflujo.length > 0 ">
                <v-card-text>
                Lista de Indicadores
                  <v-data-table
                    :headers="headerIndicador"
                    :items="gindicadorflujo"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"
                  >
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            @click="verdetalle(item)"
                          >remove_red_eye</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            v-scroll-to="'#containerflujo'"
                            @click="verflujos(item, 'Indicador')"
                          >fas fa-traffic-light</v-icon>
                        </template>
                        <span>Ver flujo</span>
                      </v-tooltip>  
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            v-scroll-to="'#containerflujo'"
                            @click="crearFlujo(item, 'Indicador')"
                          >fas fa-plus-square</v-icon>

                        </template>
                        <span>Nuevo flujo</span>
                      </v-tooltip>                                        
                    </template>              
                  </v-data-table>
                </v-card-text>

              </v-card>
            </v-flex>
            </div>
            <div v-else-if="ProcessSelected == 4">
            <v-flex xs12 sm12 v-if="gindicadorflujo != null">
              <v-card v-show="gindicadorflujo.length > 0 ">
                <v-card-text>
                Lista de Indicadores
                  <v-data-table
                    :headers="headerIndicador"
                    :items="gindicadorflujo"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"
                    :expanded.sync="expanded"
                    single-expand
                    show-expand
                    item-key="idindicador"                    
                  >
                    <template v-slot:[`item.action`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            small
                            class="mr-2"
                            @click="verdetalle(item)"
                          >remove_red_eye</v-icon>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>

                    </template>  

                  <template v-slot:expanded-item="{ headers, item }">

                    <td :colspan="headers.length" >
                      <v-container > 
                        Lista de Hitos
                        <v-data-table
                          :headers="headerHito"
                          :items="ghito"
                          class="elevation-2"
                          :no-data-text="gnodata"
                          dense
                          :items-per-page="5"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                        >
               
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  v-scroll-to="'#containerflujo'"
                                  @click="verflujos(item, 'Hito')"
                                >fas fa-traffic-light</v-icon>
                              </template>
                              <span>Ver flujo</span>
                            </v-tooltip>                        
                        </template>


                        </v-data-table>

                      </v-container>
                    </td>
                  </template>

                  </v-data-table>
                </v-card-text>

              </v-card>
            </v-flex>
            </div>
            <div v-if="ProcessSelected == 6" style="width: -webkit-fill-available;">
              <v-layout child-flex>
              <v-flex xs12 sm12 v-if="gvistanacional != null">
              <v-card v-show="gvistanacional.length > 0 ">
                <v-card-text>
                Lista de planes nacionales
                  <v-data-table
                    :headers="headerNacional"
                    :items="gvistanacional"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"
                    :expanded.sync="expanded"
                    single-expand
                    show-expand
                    item-key="idnacional"                         
                  >

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" >
                      <v-container v-if="gnacionalformulacion != null" > 
                        Lista de Formulaciones
                        <v-data-table
                          :headers="headerFormulacion"
                          :items="gnacionalformulacion"
                          class="elevation-2"
                          :no-data-text="gnodata"
                          dense
                          :items-per-page="5"
                        >
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  v-scroll-to="'#containerflujo'"
                                  @click="verflujos(item, 'Formulacion')"
                                >fas fa-traffic-light</v-icon>
                              </template>
                              <span>Ver flujo</span>
                            </v-tooltip>  
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  v-scroll-to="'#containerflujo'"
                                  @click="crearFlujo(item, 'Formulacion')"
                                >fas fa-plus-square</v-icon>
                              </template>
                              <span>Nuevo flujo</span>
                            </v-tooltip>  

                        </template>
                        </v-data-table>
                      </v-container>
                    </td>
                  </template>                               
                  </v-data-table>
                </v-card-text>
              </v-card>
              </v-flex>
              </v-layout>
            </div>
            <div v-if="ProcessSelected == 8" style="width: -webkit-fill-available;">
              <v-layout child-flex>
              <v-flex xs12 sm12 v-if="gvistanacional != null">
              <v-card v-show="gvistanacional.length > 0 ">
                <v-card-text>
                Lista de planes nacionales
                  <v-data-table
                    :headers="headerNacional"
                    :items="gvistanacional"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"
                    :expanded.sync="expanded"
                    single-expand
                    show-expand
                    item-key="idnacional"                       
                  >    

                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" >
                      <v-container > 
                        Lista de Avances Nacionales
                        <v-data-table
                          :headers="headerAvanceN"
                          :items="gavancenacionalbyplan"
                          class="elevation-2"
                          :no-data-text="gnodata"
                          dense
                          :items-per-page="5"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                        >
               
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  v-scroll-to="'#containerflujo'"
                                  @click="verflujos(item, 'AvanceNacional')"
                                >fas fa-traffic-light</v-icon>
                              </template>
                              <span>Ver flujo</span>
                            </v-tooltip>  
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  v-scroll-to="'#containerflujo'"
                                  @click="crearFlujo(item, 'AvanceNacional')"
                                >fas fa-plus-square</v-icon>
                              </template>
                              <span>Nuevo flujo</span>
                            </v-tooltip>  

                        </template>
                        </v-data-table>
                      </v-container>
                    </td>
                  </template>

                  </v-data-table>
                </v-card-text>
              </v-card>
              </v-flex>
              </v-layout>
            </div>            

            <v-divider></v-divider>
            <v-card v-if="gflujosbyelemento != null" v-show="NombreFlujo != ''" color="#EEEEEE" id="containerflujo" ref="containerflujo">
              <v-card-title>
                {{NombreFlujo}}
              </v-card-title>
              <v-card-text>
                <v-flex xs12 sm12 >
                  <v-layout row wrap>
                    <v-flex xs9> 
                    </v-flex>
                    <v-flex xs3 class="style='display: contents;'">
                      <v-switch v-model="Flujosactivos" label="Solo flujos activos" color="info" hide-details ></v-switch>
                    </v-flex>
                    </v-layout>
                  <br>
                  Lista de flujos
                  <v-data-table
                    :headers="headerFlujo"
                    :items="gflujosbyelemento"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"
                    single-expand
                    show-expand
                    item-key="idflujo"                
                  >   
                    <template v-slot:[`item.fechacreacion`]="{ item }">
                  {{ formato(item.fechacreacion, true) }}
                    </template>
                    <template v-slot:[`item.activo`]="{ item }">
                  <div v-if="item.activo  == true">Si</div>
                  <div v-else>No</div>
                    </template>
                    <template v-slot:[`item.atascado`]="{ item }">
                  <div v-if="item.atascado  == true">Si</div>
                  <div v-else>No</div>
                    </template> 
                    <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="grideditFlujo(item)"
                      >edit</v-icon>
                    </template>
                    <span>Editar</span>
                  </v-tooltip>                
                    </template>                  
                    <template v-slot:top> 
                  <v-dialog v-model="dialogFlujo" max-width="400px">
                    <v-card>
                      <v-card-text v-if="EditFlujo != null">
                        <v-layout row wrap >
                          <v-flex xs12 >
                            {{NombreFlujo}}
                          </v-flex>
                          <v-flex xs5 >
                            <v-checkbox
                              v-model="EditFlujo.activo"
                              label="Activo"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs5 >
                            <v-checkbox
                              v-model="EditFlujo.atascado"
                              label="Atascado"
                            ></v-checkbox>
                          </v-flex>                      
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn color="blue darken-1" @click="closeFlujo" >Cancelar</v-btn >
                        <v-btn color="blue darken-1" @click="saveFlujo" >Guardar</v-btn >
                      </v-card-actions>                      
                    </v-card>
                  </v-dialog>
                    </template>

                  <template v-slot:expanded-item="{ headers, item }">

                    <td :colspan="headers.length" >
                      <v-container > 
                        Lista de tareas
                        <v-data-table
                          :headers="headerTarea"
                          :items="gtareasbyelemento.filter(function (params) {return params.idflujo == item.idflujo;})  "
                          class="elevation-2"
                          :no-data-text="gnodata"
                          dense
                          color="#EEEEEE"
                          :items-per-page="10"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                        >
                        <template v-slot:[`item.fechacreacion`]="{ item }">
                      {{ formato(item.fechacreacion, true) }}
                        </template>  
                        <template v-slot:[`item.activo`]="{ item }">
                      <div v-if="item.activo  == true">Si</div>
                      <div v-else>No</div>
                        </template>                                                         
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  @click="editarTarea(item)"
                                >edit</v-icon>
                              </template>
                              <span>Editar</span>
                            </v-tooltip> 
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  @click="eliminarTarea(item)"
                                >mdi-delete</v-icon>
                              </template>
                              <span>Eliminar</span>
                            </v-tooltip>                         
                        </template>

                        <template v-slot:top> 
                      <v-dialog v-model="dialogTarea" max-width="500px">
                        <v-card>
                          <v-card-title>
                              {{EditTarea.nombre}}
                          </v-card-title>
                          <v-card-text v-if="EditTarea != null">
                            <v-layout row wrap >
                              <v-flex xs12 >
                                Usuario responsable: {{gusuarioedit.login}}
                                <v-divider></v-divider>
                                {{EditTarea.observacion}}
                              </v-flex>
                              <v-flex xs5 >
                                <v-checkbox
                                  v-model="EditTarea.activo"
                                  label="Activo"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs6 >
                                <v-text-field
                                  v-model="EditTarea.idusuarioresponsable"
                                  label="ID Usuario:"
                                ></v-text-field>
                              </v-flex> 
                              <v-flex xs5 >
                                <v-text-field
                                  v-model="EditTarea.bloqueo"
                                  label="Bloqueo:"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs6 >
                                <v-text-field
                                  v-model="EditTarea.fechabloqueo"
                                  label="Fecha Bloqueo:"
                                ></v-text-field>
                              </v-flex>                         
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn color="blue darken-1" @click="closeTarea" >Cancelar</v-btn >
                            <v-btn color="blue darken-1" @click="saveTarea" >Guardar</v-btn >
                          </v-card-actions>                      
                        </v-card>
                      </v-dialog>
                        </template>

                        </v-data-table>

                      </v-container>
                    </td>
                  </template>
                  </v-data-table>
                  <v-divider></v-divider>
                </v-flex> 
              </v-card-text>
            </v-card>
            </v-layout>
          </v-card-text>
        </v-card> 
      </v-tab-item>

      <v-tab-item>
        <v-card :elevation="2" :loading="loadingPing" :disabled="loadingPing">
          <v-card-title>
            Validación del motor
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex sm6 xs12> </v-flex>
              <v-flex sm3 xs12>
                <v-btn  color="secundary" @click="validarMotor(true)" >Enviar petición</v-btn >
              </v-flex>
              <v-flex sm3 xs12>
                <v-btn color="secundary" @click="validarMotor(false)" >Validar petición</v-btn >
              </v-flex>              
              <v-flex sm12 xs12>
                <v-alert color="blue-grey" dark dense icon="fas fa-sms" prominent >
                  <p class="font-weight-light">{{LabelPing}}</p>
                </v-alert>
              </v-flex>              
            </v-layout>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de flujos</v-card-title>
          <v-card-text >    
            <v-layout row wrap>
                <v-flex sm3 xs12>
                  <v-radio-group
                    v-model="Tiposearch"
                    row
                  >
                    <v-radio
                      label="Flujos"
                      value="flujos"
                    ></v-radio>
                    <v-radio
                      label="Tareas"
                      value="tareas"
                    ></v-radio>
                  </v-radio-group>


                </v-flex>
                <v-flex sm3 xs12 v-show="Tiposearch == 'flujos'" >
                  <v-text-field
                    v-model="CodeSearch"
                    label="ID Flujo: *"
                  ></v-text-field>
                </v-flex>
                <v-flex sm3 xs12 v-show="Tiposearch == 'tareas'">
                  <v-text-field
                    v-model="CodeSearch"
                    label="ID Tarea: *"
                  ></v-text-field>
                </v-flex>  
                <v-flex sm3 xs4 v-show="Tiposearch != null">    
                  <v-btn text @click="BuscarFlujo">Buscar</v-btn>    
                </v-flex> 
            </v-layout>  
          </v-card-text>
        </v-card>  
        <v-divider></v-divider>    
          <v-flex v-show="gflujobyid != null">
                <div v-show="Tiposearch == 'flujos'">
                  Flujos encontrados 
                  <v-data-table
                    :headers="headerFlujoSearch"
                    :items="FlujoSearch"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"              
                  >   
                  </v-data-table>    
                </div>
          </v-flex> 
        <v-flex v-show="gtareabyid != null">
          <div v-show="Tiposearch == 'tareas'">
                  Tareas encontradas
                  <v-data-table
                    :headers="headertareaSearch"
                    :items="TareaSearch"
                    class="elevation-1"
                    :no-data-text="gnodata"
                    :items-per-page="5"              
                  >   
                  </v-data-table>          
          </div>
        </v-flex> 

      </v-tab-item>
    </v-tabs>

    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{this.MesaggeInfo.codigoRespuesta}}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>

    </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
      name: "adminflujo",
    data() {
        return {
          loading: false,
          loadingPing: false,
          recargar: false,
          Loadandclear: false,
          LabelPing: '',
          CodeIndicdor:'',
          NamePlan: '',
          ProcessSelected: 0,
          ProcessSelectedName: '',
          ProcessFrom:0,
          Tiposearch: null,
          CodeSearch: 0,

          headerIndicador: [
            { text: "ID", value: "idindicador", align: " d-none" },
            { text: "Codigo", value: "codigo", align: "left",  },
            { text: "Nombre", value: "nombre", align: "left",  },
            { text: "Acciones", value: "action", sortable: false, width: "100px" },
          ],
          expanded : [],
          //==============================================================
          //flujos
          headerFlujo: [
            { text: "ID", value: "idflujo", align: "left" },
            { text: "Fecha de creación", value: "fechacreacion", align: "left",  },
            { text: "Activo", value: "activo", align: "left",  },
            { text: "Atascado", value: "atascado", align: "left",  },
            { text: "Fecha Ingreso", value: "fechaingreso", align: "left",  },
            { text: "Estado", value: "estado", align: "left",  },
            { text: "Corte", value: "fechacorte", align: "left",  },
            { text: "Entidad", value: "entidad", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ],
          FlujoSearch: [],
          headerFlujoSearch: [
            { text: "ID", value: "idflujo", align: "left" },
            { text: "Proceso", value: "nombreproceso", align: "left",  },
            { text: "Activo", value: "activo", align: "left",  },
            { text: "Atascado", value: "atascado", align: "left",  },
            { text: "Estado", value: "estado", align: "left",  },
            { text: "Corte", value: "fechacorte", align: "left",  },
            { text: "Codigo", value: "codigo", align: "left",  },
            { text: "Nombre", value: "nombre", align: "left",  },
            { text: "Entidad", value: "entidad", align: "left",  },
          ], 
          TareaSearch: [],
          headertareaSearch: [
            { text: "ID", value: "idtarea", align: "left" },
            { text: "Proceso", value: "idflujoNavigation.nombreproceso", align: "left",  },
            { text: "Activo", value: "activo", align: "left",  },
            { text: "Nombre", value: "nombre", align: "left",  },
            { text: "Rol", value: "idrol", align: "left",  },
            { text: "Titulo", value: "titulo", align: "left",  },
            { text: "Entidad", value: "idflujoNavigation.entidad", align: "left",  },
          ],                   
          Flujosactivos:true,
          NombreFlujo:'',
          dialogFlujo: false,
          SelectFlujo:[],
          EditFlujo: [],
          editedFlujoIndex: -1,

          //=========================================================================
          //tareas

          headerTarea: [
            { text: "ID", value: "idtarea", align: "left" },
            { text: "Fecha de creación", value: "fechacreacion", align: "left",  },
            { text: "Activo", value: "activo", align: "left",  },
            { text: "ID Acción", value: "idaccion", align: "left",  },
            { text: "Acción", value: "nombre", align: "left",  },
            // { text: "Responsable", value: "idusuarioresponsable", align: "left",  },
            { text: "Responsable", value: "nombreresponsable", align: "left",  },
            { text: "Bloqueado", value: "fechabloqueo", align: "left",  },
            // { text: "IDRol", value: "idrol", align: "left",  },
            { text: "Rol asignado", value: "nombreRol", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ],       
          sortBy: "idtarea",
          sortDesc: true,  
          dialogTarea: false,
          EditTarea: [],
          ClearUser: false,
          editedTareaIndex: -1,

          //=========================================================================
          //Hitos
          headerHito: [
            { text: "ID", value: "idhito", align: "left" },
            { text: "Descripción", value: "descripcion", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ], 

          //=========================================================================
          //Hitos
          headerNacional: [
            { text: "ID", value: "idnacional", align: "left" },
            { text: "Nombre", value: "descripcion", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ], 
          //=========================================================================
          //Avance Nacional
          headerAvanceN: [
            { text: "ID", value: "idavancenacional", align: "left" },
            { text: "Periodo", value: "periodos", align: "left",  },
            { text: "Rango Periodo", value: "rangoperiodo", align: "left",  },
            { text: "Estado", value: "estados", align: "left",  },
            { text: "Aprobado", value: "aprobado", align: "left",  },
            { text: "Vencido", value: "vencido", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ], 
          //errores
          snack: false,
          MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],  
          buttontext: "cerrar", 
          
          //formulacion
          headerFormulacion: [
            { text: "ID", value: "idnacionalformulacion", align: "left" },
            { text: "Plan Nacional", value: "planNacional", align: "left",  },
            { text: "Periodo", value: "periodo", align: "left",  },
            { text: "Estado", value: "estado", align: "left",  },
            { text: "Aprobado", value: "aprobado", align: "left",  },
            { text: "Acciones", value: "action", sortable: false },
          ], 

        }
    },
    $_veeValidate: {
        validator: "new",
    },
    methods: {
    ...mapActions([
      "get_procesosvisibles",
      "get_indicadorbycodigo",
      "get_nacionalbyname",
      "get_flujosbyelemento",
      "get_tareasbyelemento",
      "delete_task",
      "Gethitos",
      "PutTarea",
      "PutFlujo",
      "ClearCache",
      "get_avancenacionalbyplan",
      "CrearFlujo",
      "VerificarMotor",
      "get_formulacionbyplan",
      "get_flujobyid",
      "get_tareasbyid"

      ]),
    ...mapActions("usuario/", ["get_usuarioedit"]),
      SearchRecords(){
        if (this.ProcessFrom == 1)
          this.get_indicadorbycodigo({params: { codigo: this.CodeIndicdor }  });
        if (this.ProcessFrom == 2)
          this.get_nacionalbyname({params: { nombre: this.NamePlan }  });
      },
      LimpiarRecords(){
        this.ProcessFrom = 0;
        this.ProcessSelected = 0;
        localStorage.removeItem('ProcessSelected');
        this.CodeIndicdor = '';
        this.NamePlan = '';
        this.NombreFlujo = '';
        this.get_indicadorbycodigo({params: { codigo: -1 }  });
        this.get_flujosbyelemento({params: { idproceso:  this.ProcessSelected, idelemento: -1, activo: this.Flujosactivos } });
        this.get_nacionalbyname({params: { nombre: '0' }  });
        this.ClearCache();

      },
      verdetalle(item) {
        let global = JSON.parse(unescape(process.env.PACKAGE_JSON)).global;
        let env = global[global.env];
        this.$aes.setKey(env.path.secret);
        let cifra = this.$aes.encrypt(item.idindicador.toString());
        let temporal =   Math.random().toString(36).substring(2, 6) + cifra  +  Math.random().toString(36).substring(2, 6);
        let encrypted = this.$aes.encrypt(temporal);
        encrypted = encrypted.replace(/\//g, "AbcYq")
        encrypted = encrypted.replace(/\+/g, "qYcbA");
        this.$router.push("/detalleindicadorflujo/" + encrypted);
      },
      verflujos(item, tabla){
        this.SelectFlujo = item;
        let idsearch = 0;
        if (tabla == 'Indicador')
        {
          this.NombreFlujo = item.nombre;  
          idsearch = item.idindicador;
        } else if (tabla == 'Hito')
        {
          this.NombreFlujo = item.descripcion;  
          idsearch = item.idhito;
        } else if (tabla == 'Nacional')
        {
          this.NombreFlujo = item.nombre;  
          idsearch = item.idnacional;          
        } else if (tabla == 'Formulacion')
        {
          this.NombreFlujo = item.planNacional + item.periodo;  
          idsearch = item.idnacionalformulacion;        
        } else if (tabla == 'AvanceNacional')
        {
          this.NombreFlujo = item.rangoperiodo;  
          idsearch = item.idavancenacional;        
        }        
        this.get_flujosbyelemento({params: { idproceso:  this.ProcessSelected, idelemento: idsearch, activo: this.Flujosactivos } });
        this.get_tareasbyelemento({params: { idproceso:  this.ProcessSelected, idelemento: idsearch, activo: this.Flujosactivos } });
      },
      crearFlujo(item, tabla){
        this.SelectFlujo = item;
        let idsearch = 0;
        let nombreElemento = '';
        if (tabla == 'Indicador')
        {
          nombreElemento = item.nombre;  
          idsearch = item.idindicador;
        } else if (tabla == 'Hito')
        {
          nombreElemento = item.descripcion;  
          idsearch = item.idhito;
        } else if (tabla == 'Nacional')
        {
          nombreElemento = item.nombre;  
          idsearch = item.idnacional;          
        } else if (tabla == 'Formulacion')
        {
          this.NombreFlujo = item.planNacional + item.periodo;  
          idsearch = item.idnacionalformulacion;        
        } else if (tabla == 'AvanceNacional')
        {
          nombreElemento = item.rangoperiodo;  
          idsearch = item.idavancenacional;        
        }
        
        if (confirm("¿desea crear un nuevo flujo para el  " + this.ProcessSelectedName + " " + nombreElemento + " ? "))
        {
          this.loading = true;
          this.Loadandclear = true;  
          this.CrearFlujo({params: { idproceso:  this.ProcessSelected, idelemento: idsearch } }); 
        }       
      },
      vertareas(item, tabla){
        let idsearch = 0;
        if (tabla == 'Indicador')
        {
          this.NombreFlujo = item.nombre;  
          idsearch = item.idindicador;
        } else if (tabla == 'Hito')
        {
          this.NombreFlujo = item.descripcion;  
          idsearch = item.idhito;
        } else if (tabla == 'Nacional')
        {
          this.NombreFlujo = item.nombre;  
          idsearch = item.idnacional;          
        } else if (tabla == 'AvanceNacional')
        {
          this.NombreFlujo = item.rangoperiodo;  
          idsearch = item.idavancenacional;          
        } 
        this.get_tareasbyelemento({params: { idproceso:  this.ProcessSelected, idelemento: idsearch, activo: this.Flujosactivos } });          
      },
      formato(value, sinhora) {
        if (value && !sinhora) {
          return moment(String(value)).format("DD/MM/YYYY HH:mm");
        }
        else
        {
          return moment(String(value)).format("DD/MM/YYYY");
        }
      },
      grideditFlujo(item) {
        this.editedFlujoIndex = this.gflujosbyelemento.indexOf(item);
        this.EditFlujo = Object.assign({}, item);
        this.dialogFlujo = true;
      }, 
      closeFlujo(){
        this.dialogFlujo = false;
        this.EditFlujo = [];
      },
      saveFlujo(){
          if (this.editedFlujoIndex > -1) {
              this.loading = true;
              Object.assign(this.gflujosbyelemento[this.editedFlujoIndex], this.EditFlujo );
              this.PutFlujo({data: this.EditFlujo });
          }
          this.dialogFlujo = false;
          this.loading = false;
      },   
      editarTarea(item) {
        this.editedTareaIndex = this.gtareasbyelemento.indexOf(item);
        this.EditTarea = Object.assign({}, item);
        if (item.idusuarioresponsable != null)
          this.get_usuarioedit({ params: { idusuario: item.idusuarioresponsable, }, });
        this.dialogTarea = true;
      }, 
      closeTarea() {
        this.dialogTarea = false;
        this.EditTarea = [];
      },  
      saveTarea() {
          if (this.editedTareaIndex > -1) {
              this.loading = true;
              this.recargar = true;
              if (this.EditTarea.idusuarioresponsable == '')
                this.EditTarea.idusuarioresponsable = null;
              if (this.EditTarea.bloqueo == '')
                this.EditTarea.bloqueo = null;
              if (this.EditTarea.fechabloqueo == '')
                this.EditTarea.fechabloqueo = null;      
              if (this.EditTarea.activo == true)
                this.EditTarea.finalizado = null; 
              else
                this.EditTarea.finalizado = true; 
              Object.assign(this.gtareasbyelemento[this.editedTareaIndex], this.EditTarea );
              this.PutTarea({data: this.EditTarea });
          }
          this.dialogTarea = false;
      },
      eliminarTarea(item) {
        if (confirm("¿Esta seguro de eliminar la tarea " + item.nombre + " ? "))
        {
          this.loading = true;
          this.recargar = true;   
          this.delete_task({params: { idtarea:  item.idtarea } });                 
        }
      },
      validarMotor(item){
        this.loadingPing = true;
        this.VerificarMotor({params: { sendping:  item } });  
      },
      BuscarFlujo(){
        if (this.Tiposearch == "flujos"){
          this.get_flujobyid({params: { idflujo:  this.CodeSearch } });
        } else if (this.Tiposearch == "tareas")
        {
          this.get_tareasbyid({params: { idtarea:  this.CodeSearch } });
        }
        this.CodeSearch = 0;
      }  
    },
    created() {
      this.get_procesosvisibles()
      if (this.gindicadorflujo == null && this.gnacionalformulacion == null)
        localStorage.removeItem('ProcessSelected');
    },
    mounted() {
      if (localStorage.ProcessSelected != undefined)
          this.ProcessSelected = parseInt(localStorage.ProcessSelected);
    },
    computed: {
    ...mapGetters([
      "gprocesosactivos",
      "gindicadorflujo",
      "gvistanacional",
      "gflujosbyelemento",
      "gtareasbyelemento",
      "ghito",
      "gavancenacionalbyplan",
      "gnacionalformulacion",
      "gflujobyid",
      "gtareabyid"

    ]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuarioedit"]),
  },
  watch: {
    ProcessSelected: function(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        localStorage.setItem("ProcessSelected", JSON.stringify(newValue));
        let Process = this.gprocesosactivos.filter(function (params) {
            return params.idproceso == newValue;
          })      
        if (Process != undefined)
        {
          if (Process.length > 0)
          {
            this.ProcessFrom = Process[0].idtipoproceso
            this.ProcessSelectedName = Process[0].nombre
          }
        }
      }
    },
    Flujosactivos: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.SelectFlujo.codigo != undefined || this.SelectFlujo.idhito != undefined || this.SelectFlujo.idnacional != undefined  || this.SelectFlujo.idavancenacional != undefined )
        {
        if (this.ProcessSelected == 4)
          this.verflujos(this.SelectFlujo, 'Hito')
        else if (this.ProcessSelected == 6)
          this.verflujos(this.SelectFlujo, 'Formulacion')
        else if (this.ProcessSelected == 8)
          this.verflujos(this.SelectFlujo, 'AvanceNacional')          
        else
          this.verflujos(this.SelectFlujo, 'Indicador')
        }
      }
    },
    ginformation() {
        if (this.loading)
        {
          this.MesaggeInfo = this.ginformation;
          this.snack = true;
          this.buttontext = "aceptar";
          console.log(this.MesaggeInfo.mensajeRespuesta);   
          this.loading = false;       
        } else if (this.loadingPing)
        {
          this.MesaggeInfo = this.ginformation;
          this.loadingPing = false;
          this.LabelPing = this.LabelPing + " ... " + this.MesaggeInfo.mensajeRespuesta;
        }
        if (this.recargar)
        {
          if (this.ginformation.idGenerado == 1)
          {
            if (this.SelectFlujo.codigo != undefined || this.SelectFlujo.idhito != undefined || this.SelectFlujo.idnacional != undefined  || this.SelectFlujo.idavancenacional != undefined ) {
              if (this.ProcessSelected == 4)
                this.vertareas(this.SelectFlujo, 'Hito')
              else if (this.ProcessSelected == 6)
                this.vertareas(this.SelectFlujo, 'Nacional')
              else if (this.ProcessSelected == 8)
                this.vertareas(this.SelectFlujo, 'AvanceNacional')          
              else
                this.verflujos(this.SelectFlujo, 'Indicador')
            }
          } else
          {
            this.MesaggeInfo = this.ginformation;
            this.snack = true;
            console.log(this.MesaggeInfo.mensajeRespuesta);
          }
          this.recargar = false;
        } else if (this.Loadandclear)
        {
          if (this.ginformation.idGenerado == 1)
          {
          this.LimpiarRecords();
          this.Loadandclear = false;
          }
        }
    },
    expanded: function(newValue, oldValue){
      if (newValue && newValue !== oldValue) {
        if (this.expanded.length > 0){
          if (this.ProcessSelected == 4)
            this.Gethitos({params: { idindicador:  this.expanded[0].idindicador } });
          if (this.ProcessSelected == 6)
          {
            this.get_formulacionbyplan({params: { idnacional:  this.expanded[0].idnacional } });
          }
          if (this.ProcessSelected == 8)
          {
            this.get_avancenacionalbyplan({params: { idnacional:  this.expanded[0].idnacional } });
          }
        }
      }
    },
    gflujobyid: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.FlujoSearch = this.gflujobyid;
      }
    },
    gtareabyid:  function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.TareaSearch = this.gtareabyid;
      }
    }
  }

}
</script>